import { computed as t } from "vue";
function r() {
  const o = t(() => "ontouchstart" in window || navigator.msMaxTouchPoints), n = t(() => document.documentElement.dir === "rtl");
  return {
    isTouchDevice: o,
    isRtl: n
  };
}
export {
  r as default
};
//# sourceMappingURL=design-system.es146.js.map
